export const TRANSACTIONBYPROXY = 'ATP';
export const NOTARIZEDBYPROXY = 'ATPN';
